// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search {
  display: grid;
  width: 100%;
  grid-template-columns: 40px 1fr;
}
.searchIcon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.searchIcon i {
  font-size: 22px;
}
.searchForm input {
  color: #353535;
  background-color: #F4F8F9;
  width: min-content;
  outline: unset;
  border: unset;
}
.searchForm input:focus {
  outline: unset;
  border: unset;
}
.searchForm :global .form-group {
  margin-bottom: unset;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/DataGridSearch.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,WAAA;EACA,+BAAA;AADF;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAFF;AADA;EAKI,eAAA;AADJ;AAKA;EAEM,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;AAJN;AAFA;EASM,cAAA;EACA,aAAA;AAJN;AANA;EAcM,oBAAA;AALN","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.search {\n  display: grid;\n  width: 100%;\n  grid-template-columns: 40px 1fr;\n}\n\n.searchIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  i {\n    font-size: 22px;\n  }\n}\n\n.searchForm {\n    input {\n      color: @text-gray1;\n      background-color: @background-gray4;\n      width: min-content;\n      outline: unset;\n      border: unset;\n    }\n    input:focus {\n      outline: unset;\n      border: unset;\n    }\n\n    :global .form-group {\n      margin-bottom: unset;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
